import FormContainer from "../../../components/formContainer/FormContainer";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import OverlayLoader from "../../../components/loader/OverlayLoader/OverlayLoader";
import Select from "../../../components/select/main/Select";
import { useLanguageContext } from "../../../context/LanguageContext";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../styles/InputStyles";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../styles/LayoutStyles";

function VersteijnenConfigsPageView({
  configData,
  submitError,
  onSubmit,
  onActiveChange,
  onUrlChange,
  onUsernameChange,
  onPasswordChange,
  onSenderUuidChange,
  onMessageTypeCodeChange,
  onReportIdChange,
}) {
  const { translate } = useLanguageContext();

  return (
    <OverlayLoader groups="versteijnen_configs_page_fetch">
      <FormContainer
        onSubmit={onSubmit}
        submitError={submitError}
        submitLoadingGroup={"versteijnen_configs_page_save"}
      >
        <StyledFlexColumn>
          <InputWrapper
            label={translate("eva.main.validation.attributes.active")}
            required
            error={EVAApiHelper.getResponseError("active", submitError)}
          >
            <Select
              options={[
                { value: true, label: translate("eva.main.general.yes") },
                { value: false, label: translate("eva.main.general.no") },
              ]}
              value={configData.active}
              onChange={onActiveChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.url")}
            required
            error={EVAApiHelper.getResponseError("url", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.url")}
              value={configData.url}
              onChange={onUrlChange}
            />
          </InputWrapper>

          <StyledFlexRow>
            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.username")}
                required
                error={EVAApiHelper.getResponseError("username", submitError)}
              >
                <StyledInput
                  type="text"
                  placeholder={translate(
                    "eva.main.validation.attributes.username",
                  )}
                  value={configData.username}
                  onChange={onUsernameChange}
                />
              </InputWrapper>
            </StyledFlexItem>

            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.password")}
                required
                error={EVAApiHelper.getResponseError("password", submitError)}
              >
                <StyledInput
                  type="text"
                  placeholder={translate(
                    "eva.main.validation.attributes.password",
                  )}
                  value={configData.password}
                  onChange={onPasswordChange}
                />
              </InputWrapper>
            </StyledFlexItem>
          </StyledFlexRow>

          <InputWrapper
            label={translate("eva.main.validation.attributes.sender_uuid")}
            error={EVAApiHelper.getResponseError("sender_uuid", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate(
                "eva.main.validation.attributes.sender_uuid",
              )}
              value={configData.sender_uuid}
              onChange={onSenderUuidChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate(
              "eva.main.validation.attributes.message_type_code",
            )}
            error={EVAApiHelper.getResponseError(
              "message_type_code",
              submitError,
            )}
          >
            <StyledInput
              type="text"
              placeholder={translate(
                "eva.main.validation.attributes.message_type_code",
              )}
              value={configData.message_type_code}
              onChange={onMessageTypeCodeChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.report_id")}
            error={EVAApiHelper.getResponseError("report_id", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate(
                "eva.main.validation.attributes.report_id",
              )}
              value={configData.report_id}
              onChange={onReportIdChange}
            />
          </InputWrapper>
        </StyledFlexColumn>
      </FormContainer>
    </OverlayLoader>
  );
}

export default VersteijnenConfigsPageView;